import React from 'react'
import { useTranslation } from 'react-i18next'
import { getEntityNameLocoKeyByEntityType } from 'src/editor/shared/utils/get-entity-name-loco-key-by-entity-type'
import { twMerge } from 'tailwind-merge'
import { useBreadcrumbs } from './hooks/use-breadcrumbs'

export const Breadcrumbs = () => {
  const { t } = useTranslation()
  const {
    setRef,
    setMeasureRef,
    filteredBreadcrumbs,
    visibleBreadcrumbs,
    handleHighlight,
    handleToggleSettings,
  } = useBreadcrumbs()

  return (
    <>
      <div
        ref={setMeasureRef}
        className="pointer-events-none invisible absolute top-0 left-[-9999px] h-0 items-center overflow-hidden text-ellipsis whitespace-nowrap border-divider01 border-l px-4.5 py-2.75 text-M"
        aria-hidden="true"
      >
        {filteredBreadcrumbs.map((b, i, arr) => (
          <span key={b.id} className="group">
            <button type="button" className="relative px-3.5">
              {t(getEntityNameLocoKeyByEntityType(b.type))}
            </button>
            {arr.length > i + 1 && <i className="fa-solid fa-chevron-right" />}
          </span>
        ))}
      </div>
      <div
        ref={setRef}
        className={twMerge(
          'w-full items-center text-ellipsis whitespace-nowrap border-divider01 border-l bg-bgPrimaryBase px-4.5 py-2.75 text-M',
          filteredBreadcrumbs.length ? 'flex' : 'hidden',
        )}
      >
        {visibleBreadcrumbs.map((b, i, arr) => (
          <React.Fragment key={b.id}>
            {arr.length > i + 1 ? (
              // biome-ignore lint/a11y/noStaticElementInteractions: <explanation>
              <span
                className="group"
                onClick={handleToggleSettings(b.id)}
                onMouseOver={handleHighlight(b.id)}
                onMouseOut={handleHighlight()}
              >
                <button
                  type="button"
                  className="relative cursor-pointer px-3.5 text-textTertiary group-hover:text-textSecondary"
                >
                  {t(getEntityNameLocoKeyByEntityType(b.type))}
                </button>
                <i className="fa-solid fa-chevron-right cursor-pointer text-iconTertiary group-hover:text-iconSecondary" />
              </span>
            ) : (
              <button
                type="button"
                className="relative cursor-pointer pr-3 pl-3.5 text-textLink hover:text-textLinkHover"
                onMouseOver={handleHighlight(b.id)}
                onMouseOut={handleHighlight()}
              >
                {t(getEntityNameLocoKeyByEntityType(b.type))}
              </button>
            )}
          </React.Fragment>
        ))}
      </div>
    </>
  )
}
